export default "__VITE_ASSET__WMzawFC9__"